import { useCallback } from "react";
import { useAccount as userWeb3Account, useDisconnect } from "wagmi";
import store, { useTypedSelector, actions } from "@/stores";
import { checkLogin, LoginState } from "@form/services/account";
import {
  useConnectModal,
  useAccountModal,
  useChainModal,
} from "@rainbow-me/rainbowkit";

export default function useAccount() {
  const { isConnected, address, status } = userWeb3Account();
  const { openConnectModal } = useConnectModal();
  const { disconnect } = useDisconnect();

  const session = useTypedSelector((state) => {
    return state.account.session;
  });

  const isLogin = checkLogin(session) && isConnected && status === "connected";
  const isAdmin = session ? session.isAdmin : false;

  const login = useCallback(async () => {
    store.dispatch(actions.account.startLogin());
    if (!isConnected && openConnectModal) {
      openConnectModal();
    }
  }, [isConnected, openConnectModal]);

  return {
    login,
    logout: disconnect as any,
    isLogin,
    address,
    isAdmin,
  };
}
